import React, { memo } from '../../../lib/teact/teact';
import Icon from '../icons/Icon';
import styles from './PwaInstallModal.module.scss';
import buildClassName from '../../../util/buildClassName';
import useLastCallback from '../../../hooks/useLastCallback';
import { IS_IOS, IS_ANDROID } from '../../../util/browser/windowEnvironment';

type OwnProps = {
  isOpen: boolean;
  onClose: () => void;
};

const PwaInstallModal = ({ isOpen, onClose }: OwnProps) => {
  const handleBackdropClick = useLastCallback((e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  });

  return (
    <div 
      className={buildClassName(styles.overlay, isOpen && styles.open)} 
      onClick={handleBackdropClick}
    >
      <div className={styles.modalCard}>
        <button type="button" className={styles.closeButton} onClick={onClose} aria-label="Close">
          <Icon name="close" />
        </button>
        
        <div className={styles.header}>
          <img src="app-logo.png" alt="Larpers" className={styles.appIcon} />
          <div className={styles.headerText}>
            <h2 className={styles.title}>Install App</h2>
            <p className={styles.description}>
              Add to home screen for instant trades and native UI.
            </p>
          </div>
        </div>

        <div className={styles.instructionsList}>
          {IS_IOS ? (
            <>
              <div className={styles.instructionItem}>
                <div className={styles.iconWrapper}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                    <polyline points="16 6 12 2 8 6" />
                    <line x1="12" y1="2" x2="12" y2="15" />
                  </svg>
                </div>
                <div className={styles.instructionText}>
                  <span className={styles.stepNumber}>1</span>
                  <span className={styles.stepDesc}>Tap Share</span>
                </div>
              </div>

              <div className={styles.instructionItem}>
                <div className={styles.iconWrapper}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <polyline points="19 12 12 19 5 12" />
                  </svg>
                </div>
                <div className={styles.instructionText}>
                  <span className={styles.stepNumber}>2</span>
                  <span className={styles.stepDesc}>Scroll down</span>
                </div>
              </div>
              
              <div className={styles.instructionItem}>
                <div className={styles.iconWrapper}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="3" width="18" height="18" rx="4" ry="4" />
                    <line x1="12" y1="8" x2="12" y2="16" />
                    <line x1="8" y1="12" x2="16" y2="12" />
                  </svg>
                </div>
                <div className={styles.instructionText}>
                  <span className={styles.stepNumber}>3</span>
                  <span className={styles.stepDesc}>Add to Home Screen</span>
                </div>
              </div>
            </>
          ) : IS_ANDROID ? (
            <>
              <div className={styles.instructionItem}>
                <div className={styles.iconWrapper}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="1" />
                    <circle cx="12" cy="5" r="1" />
                    <circle cx="12" cy="19" r="1" />
                  </svg>
                </div>
                <div className={styles.instructionText}>
                  <span className={styles.stepNumber}>1</span>
                  <span className={styles.stepDesc}>Tap Menu (3 dots)</span>
                </div>
              </div>
              
              <div className={styles.instructionItem}>
                <div className={styles.iconWrapper}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="3" width="18" height="18" rx="4" ry="4" />
                    <line x1="12" y1="8" x2="12" y2="16" />
                    <line x1="8" y1="12" x2="16" y2="12" />
                  </svg>
                </div>
                <div className={styles.instructionText}>
                  <span className={styles.stepNumber}>2</span>
                  <span className={styles.stepDesc}>Add to Home screen</span>
                </div>
              </div>
            </>
          ) : null}
        </div>

        {IS_IOS && (
          <div className={styles.pointerArrow}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="12" y1="5" x2="12" y2="19" />
              <polyline points="19 12 12 19 5 12" />
            </svg>
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(PwaInstallModal);
